"use client";

import { useProfileContext } from "../../../context/ProfileContext";

const Profile = () => {
  const {selectedProfile} = useProfileContext();
  return (
    <div className="mb-8 text-center">
      <div className="bg-white/90 backdrop-blur-sm rounded-3xl p-8 shadow-xl border border-white/30 transform hover:scale-105 transition-all duration-300">
        <div className="flex flex-col items-center gap-4">
          <div
            className={`text-8xl transition-transform duration-600 hover:scale-110 cursor-pointer`}
          >
            👦
          </div>
          <div className="text-center">
            <h1 className="text-4xl font-bold bg-gradient-to-r from-purple-600 to-pink-600 bg-clip-text text-transparent mb-3">
              Hello, {selectedProfile.studentName} 🌟
            </h1>
            <div className="flex items-center justify-center gap-3">
              <div className="w-4 h-4 bg-green-400 rounded-full animate-pulse shadow-lg"></div>
              <span className="text-xl text-gray-700 font-semibold">
                Ready to learn and have fun!
              </span>
              <div className="text-2xl animate-bounce">🎉</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
